import { PromptFunction } from '../../types';

/**
 * 章节相关函数
 * @returns 章节相关函数对象
 */
const chaptersFunctions: Record<string, PromptFunction> = {

}

export default chaptersFunctions;